module.exports = __webpack_public_path__ + "static/media/outsource.83bc0d31.svg";